import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.64528, 166.936126, 2.2],
  [-11.64519, 166.936055, 2.2],
  [-11.645098, 166.935988, 2.2],
  [-11.645003, 166.935926, 2.2],
  [-11.644904, 166.935866, 2.2],
  [-11.644805, 166.935811, 2.2],
  [-11.644701, 166.935758, 2.2],
];

export default stream;
